import { createI18n } from 'vue-i18n'
import vi from '@/locales/vi.json'
import en from '@/locales/en.json'

export type MessageSchema = typeof vi

const i18n = createI18n<[MessageSchema], 'vi' | 'en'>({
  legacy: false, // You must set `false`, to use Composition API
  locale: 'vi', // set locale
  fallbackLocale: 'en', // set fallback locale
  warnHtmlInMessage: 'off',
  warnHtmlMessage: false,
  messages: {
    vi,
    en,
  },
})

export default i18n
